import { type ComponentProps } from "react";

import type { ChillnnStudioDriver } from "@/lib/chillnn-studio-driver";
import { type SnackNewItem_SnackEditPageQuery } from "@/lib/gql/__generated__/graphql";

import { useCreateSnackEditorBaseModel } from "../../../../_shared/model/use-create-snack-editor-base-model";

import type { SnackFormModelType } from "../use-create-snack-form-model";

type Props = {
	hotelID: string;
	data: SnackNewItem_SnackEditPageQuery;

	snackFormModel: SnackFormModelType;
};

type ChillnnStudioDriverProps = ComponentProps<typeof ChillnnStudioDriver>;

export const useCreateSnackModel = ({ hotelID, data, snackFormModel }: Props): ChillnnStudioDriverProps => {
	const {
		planList,
		roomList,
		snackList,
		snackNewItem,
		snackListParentTemplate,
		snackListSystemTemplate,
		snackTemplateSystem,
		hotel,
	} = data;

	return {
		...useCreateSnackEditorBaseModel({
			hotelID,

			snackFormModel,

			editorBaseProps: {
				planList,
				roomList,
				snackListParentTemplate,
				snackListSystemTemplate,
				snackTemplateSystem,
				targetSnackItem: {
					isNew: true,
					uuid: snackNewItem.uuid,
				},
			},

			snackList,

			hotel,
		}),
	};
};
